//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Loading from '@/components/views/loading'
import BlogItem from './_components/_blog'
import search from './_components/_search'
import tagFilter from './_components/_tag_filter'
const TAGS = [
    {
        id: 0,
        tag_name: '全部',
        value: ''
    },
    {
        id: 1,
        tag_name: '样板间',
        value: '样板间'
    },
    {
        id: 2,
        tag_name: '周边设施',
        value: '周边设施'
    },
    {
        id: 3,
        tag_name: '现场动态',
        value: '现场动态'
    },
    {
        id: 4,
        tag_name: '社区配套',
        value: '社区配套'
    },
    {
        id: 5,
        tag_name: '其他',
        value: '其他'
    },
]
export default {
    data() {
        return {
            tags:  TAGS,
            select_tag: '全部'
        }
    },
    methods: {
        changeTag(val) {
            this.$emit('changeTag', val)
            this.select_tag = val
        },
        goEdit () {
            wx.navigateTo({
                url: '/consultants/feeds/edit'
            })
        },
        onDelete (id) {
            this.$emit('delete', id)
        },
        onChangeFeed (item) {
            this.$emit('changeFeed', item)
        },
        onSticky (id) {
            wx.createSelectorQuery().in(this)
                .select(".blog-item")
                .boundingClientRect()
                .selectViewport().scrollOffset()
                .exec((res)=>{
                    const top = res && res[0] && res[0].top
                    const scrollTop = res && res[1] && res[1].scrollTop
                    wx.pageScrollTo({
                        scrollTop: top + scrollTop
                    })
                })
            this.$emit('sticky', id)
        },
    },
    components: {
        Loading,
        BlogItem,
        search,
        tagFilter
    },
    props: {
        no_more: {
            type: Boolean,
        },
        feeds: {
            type: Array
        },
        feeds_loading: {
            type: Boolean
        },
        showEdit: {
            type: Boolean
        },
        consultant_id: {
            type: String
        },
        total_count: {
            type: Number
        }
    }
}
